import { TypeKeys, WidgetBlockAction } from './types';

type ReportSiteAction<T> = WidgetBlockAction<TypeKeys.SET_REPORT_SITE, { site: T }>;

/**
 * @deprecated since version 4.2.0.
 * Use action widgetTemplateLoaded and pass {site} object instead
 *
 * @param {*} widgetId
 * @param {*} instanceId
 * @param {*} site
 */
const setReportSite = <T>(widgetId: string, instanceId: string, site: T): ReportSiteAction<T> => {
    console.warn('setReportSite is deprecated. Use action widgetTemplateLoaded and pass {site} object instead');

    return {
        type: TypeKeys.SET_REPORT_SITE,
        payload: {
            widgetId,
            instanceId,
            site,
        },
    };
};

export default setReportSite;
export { ReportSiteAction };
